import { render } from "./Chats.vue?vue&type=template&id=55bf2d58"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"
script.render = render

export default script